webpackJsonp([142629428675168],{

/***/ 396:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Stripeo and Amaza the Pirate Princess","description":"A dad writes a book about building Do-It-Yourself online payment with Stripe, Gatsby.js and Amaza Serveless Functions"}},"allMarkdownRemark":{"edges":[{"node":{"excerpt":"","fields":{"slug":"/glasur/"},"frontmatter":{"title":"Part 2"}}},{"node":{"excerpt":"","fields":{"slug":"/hei-lo-mammaen-min-kan-mer-om-it-enn-dere/"},"frontmatter":{"title":"Part 3"}}},{"node":{"excerpt":"Introduction  Get a Stripe account here first. Make a Gatsby site.","fields":{"slug":"/Litt om passord og hvorfor et passord-håndteringsprogram er løsningen/"},"frontmatter":{"title":"Part 1"}}}]}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---index-5c89ca258e35167daec8.js